import React from 'react';
import styles from './grid.module.scss';


export function Container({className, ...props}) {
    return <div className={styles.container} {...props} />;
}



// WEBPACK FOOTER //
// ./src/ui/grid/index.js